'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-conversations',
        name: 'ai-conversations',
        meta: {
            title: 'AI conversations',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-conversations/index'),
    },
];
